export const AttributeRuleConstant = {
    STATUS_VALID: "VALID",
    STATUS_INVALID: "INVALID"
}
